import { Flex, styled } from "@acko-tech/building-blocks.ui.common";

export const Wrapper = styled(Flex)`
  box-sizing: border-box;
  flex-shrink: 0;
  flex-direction: row;
  gap: 8px;
  padding-top: ${(props) => (props.isDesktop ? "1.5rem" : 0)};
  margin-bottom: 32px;
`;

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;
  align-items: flex-start;

  &.year-column {
    flex: 0.5;
    display: flex;
    flex-direction: column;

    .year-item {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      ${(props) =>
        props.rowCount === 3 &&
        `
        height: auto; 
        padding-top: 10px;
        padding-bottom: 10px;
      `}
    }
  }
  .year-item:nth-of-type(3) .bold {
    margin-top: -15px;
  }
`;

export const TextBox = styled.div`
  border-radius: 8px;
  font-size: 12px;
  line-height: 18px;
  color: #5b5675;
  font-weight: 500;

  &.bold {
    font-weight: bold;
    color: #36354c;
  }

  &.desc {
    font-size: 10px;
    line-height: 14px;
    font-weight: 400;
  }
  
  &.heading {
    text-align: center;
    background: #5B5675;
    color: #fff;
    padding: 8px;
    width: ${(props)=> (props.isDesktop ? "90%" : "88%")};
    border-radius: 4px
  }
`;
